<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl font-bold">Module 3: Values</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Values are the principles and beliefs that guide employees on how they are
      to interact with each other and treat customers. By going through this
      module, you will better understand what Values are, why Values are
      important, and the steps you need to follow to create your own. You then
      “Do The Work” and identify your company Values which you can enter into
      the One Page View.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083793"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-3xl font-bold">3.2 What are Values?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I teach you the definition of Values and share with you two examples of
      some well-known companies.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083836"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-3xl font-bold">3.3 Why are Values Important?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you five key reasons why values are important and the impact
      they will have on you, your employees, and your business.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083891"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-3xl font-bold">3.4 How to Identify</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I give you four places you can look to uncover your company values and the
      four-step process you need to follow (also detailed in the chapter
      provided in the Download Assets). I then take you through the five
      questions you need to answer that will help you test the strength of the
      values you have selected.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083934"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-3xl font-bold">3.5 Flint Inc. Values</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you how the President of Flint Inc. followed our process to
      identify his company's top five Values.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084022"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-3xl font-bold">3.6 Do the Work</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      This module is focused on having you craft your company's Values.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084104"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-3xl font-bold">3.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I ask you to reflect upon the Values learning module. I end
      the video by giving you a brief overview of the Blue Sky Vision module
      which is next.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284831685"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{/if}
